import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RepositoryRoutingModule } from './repository-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../core/material.module';
import { DialogDataDialog, RepositoryComponent } from './repository-report/repository.component';
// import { ReportDetailsComponent } from './report-details/report-details.component';
import { TableExtractionComponent } from './table-extraction/table-extraction.component';
import { TableExtractionGridComponent } from './table-extraction/table-extraction-grid/table-extraction-grid.component';
import { TableExtractionFilterComponent } from './table-extraction-filter/table-extraction-filter.component';
import { ClubComponent } from './table-extraction-filter/club/club.component';
import { FilterSaveComponent } from './table-extraction-filter/filter-save/filter-save.component';
import { ExpandMode, NgxTreeSelectModule } from '../../ngx-tree-select/src';
import { AgGridModule } from 'ag-grid-angular';
import { SharedRepositoryModule } from '../shared-repository/shared-repository.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SigTestComponent } from './significance-testing/sig-test/sig-test.component';
import { SigResultComponent } from './significance-testing/sig-result/sig-result.component';
import { SigTestModalComponent } from './significance-testing/sig-test-modal/sig-test-modal.component';
import { AllFileListComponent } from './all-file-list/all-file-list.component';
import { MoveAllFileComponent } from './all-file-list/move-all-file/move-all-file.component';


@NgModule({
  declarations: [
    RepositoryComponent,
    DialogDataDialog,
    SigTestModalComponent,
    // ReportDetailsComponent,
    TableExtractionComponent,
    TableExtractionGridComponent,
    TableExtractionFilterComponent,
    ClubComponent,
    SigTestComponent,
    SigResultComponent,
    FilterSaveComponent,
    AllFileListComponent,
    MoveAllFileComponent,
  ],
  imports: [
    CommonModule,
    RepositoryRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    SharedModule,
    SharedRepositoryModule,
    MaterialModule,
    AgGridModule.withComponents([]),
    NgxTreeSelectModule.forRoot({
      idField: 'id',
      textField: 'name',
      expandMode: ExpandMode.Selection,
    }),
  ],
  entryComponents:[
    DialogDataDialog,
    SigTestModalComponent
  ]
})
export class RepositoryModule { }
